<template>
  <el-container>
    <el-header>
      <common-header/>
    </el-header>
    <div class="banner banner1">
      <div class="maincontainer">
        <div class="iconapply"></div>
        <div class="title">{{ $t('lang.chooseCert.wantToApply') }}</div>
        <div class="step">
          <div class="step-title">{{ $t('lang.chooseCert.chooseCert') }}</div>
          <div class="step-no">STEP<span>1</span></div>
        </div>
      </div>
    </div>
    <el-main>
      <div class="maincontainer" style="padding: 20px 0">
        <el-collapse v-model="activeNames" style="margin: 0 20px">
          <el-collapse-item name="standard" v-if="standardList.length > 0">
            <template slot="title">
              {{ $t('lang.chooseCert.standardCert') }}
              <i :class="isActive('standard') ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
              <div class="price">
                <span class="unit">CNY</span>
                <span class="amount">{{ standardAmount | moneyFormat }}</span>
              </div>
            </template>
            <div class="filelist">
              <el-row class="rowheader">
                <template v-if="applyVo.applyType === 'PAPER'">
                  <el-col :span="14" :offset="1">{{ $t('lang.chooseCert.certName') }}</el-col>
                  <!--                  <el-col :span="5">{{ $t('lang.chooseCert.needUploadAttachment') }}</el-col>-->
                  <el-col :span="5" style="text-align:center">{{ $t('lang.chooseCert.amount') }}</el-col>
                  <el-col :span="2" style="text-align:center">{{ $t('lang.chooseCert.price') }}</el-col>
                  <el-col :span="2" style="text-align:center">{{ $t('lang.chooseCert.sumAmount') }}</el-col>
                </template>
                <template v-if="applyVo.applyType === 'ELECTRONIC'">
                  <el-col :offset="1" :span="21">{{ $t('lang.chooseCert.certName') }}</el-col>
                  <!--                  <el-col :span="11">{{ $t('lang.chooseCert.needUploadAttachment') }}</el-col>-->
                  <el-col :span="2" style="text-align: center">{{ $t('lang.chooseCert.sumAmount') }}</el-col>
                </template>
              </el-row>

              <el-row
                class="filerow"
                :class="item.checked ? 'rowselected' : ''"
                v-for="(item, index) in standardList"
                :key="index"
              >
                <el-col :span="1">
                  <el-checkbox v-model="item.checked" :disabled="disabled"></el-checkbox>
                </el-col>
                <template v-if="applyVo.applyType === 'PAPER'">
                  <el-col :span="14">{{ isZh ? item.chineseName : item.englishName }}</el-col>
                  <!--                  <el-col :span="5" class="fileuploadcontainer">
                                      <div>{{ item.needUploadAttachment === 'Y' ? $t('lang.common.yes') : $t('lang.common.no') }}</div>
                                      <div v-if="item.needUploadAttachment === 'Y'" style="margin-left: 40px">
                                        <div @click="openDrawer(item)">
                                          <i class="icon iconfont icon-shangchuanwenjian11"></i>
                                          {{ item.attachmentName || $t('lang.common.uploadAttachment') }}
                                        </div>
                                      </div>
                                    </el-col>-->
                  <el-col :span="5" style="text-align:center">
                    <el-input-number size="mini" :min="1" v-model="item.copyNumber"
                                     :disabled="disabled || !item.checked"></el-input-number>
                  </el-col>
                  <el-col :span="2" class="fileprice">{{ certPrice(item) | moneyFormat }}</el-col>
                  <el-col :span="2" class="fileprice">{{ certChargeAmount(item) | moneyFormat }}
                  </el-col>
                </template>
                <template v-if="applyVo.applyType === 'ELECTRONIC'">
                  <el-col :span="21">{{ isZh ? item.chineseName : item.englishName }}</el-col>
                  <!--                  <el-col :span="11" class="fileuploadcontainer">
                                      <div>{{ item.needUploadAttachment === 'Y' ? $t('lang.common.yes') : $t('lang.common.no') }}</div>
                                      <div v-if="item.needUploadAttachment === 'Y'" style="margin-left: 40px">
                                        <div @click="openDrawer(item)">
                                          <i class="icon iconfont icon-shangchuanwenjian11"></i>
                                          {{ item.attachmentName || $t('lang.common.uploadAttachment') }}
                                        </div>
                                      </div>
                                    </el-col>-->
                  <el-col :span="2" class="fileprice">{{ certChargeAmount(item) | moneyFormat }}</el-col>
                </template>
              </el-row>
            </div>
          </el-collapse-item>
          <el-collapse-item name="nonStandard">
            <template slot="title">
              {{ $t('lang.chooseCert.nonStandardCert') }}
              <i :class="isActive('nonStandard') ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
              <div class="price">
                <span class="unit">CNY</span>
                <span class="amount">{{ nonStandardAmount | moneyFormat }}</span>
              </div>
            </template>
            <div class="filelist">
              <el-row class="rowheader">
                <template v-if="applyVo.applyType === 'PAPER'">
                  <el-col :offset="1" :span="9">{{ $t('lang.chooseCert.certName') }}</el-col>
                  <el-col :span="5">{{ $t('lang.chooseCert.needUploadAttachment') }}</el-col>
                  <el-col :span="5" style="text-align:center">{{ $t('lang.chooseCert.amount') }}</el-col>
                  <el-col :span="2" style="text-align:center">{{ $t('lang.chooseCert.price') }}</el-col>
                  <el-col :span="2" style="text-align:center">{{ $t('lang.chooseCert.sumAmount') }}</el-col>
                </template>
                <template v-if="applyVo.applyType === 'ELECTRONIC'">
                  <el-col :offset="1" :span="10">{{ $t('lang.chooseCert.certName') }}</el-col>
                  <el-col :span="11">{{ $t('lang.chooseCert.needUploadAttachment') }}</el-col>
                  <el-col :span="2" style="text-align: center">{{ $t('lang.chooseCert.sumAmount') }}</el-col>
                </template>
              </el-row>

              <el-row
                class="filerow"
                :class="item.checked ? 'rowselected' : ''"
                v-for="(item, index) in nonStandardList"
                :key="index"
              >
                <el-col :span="1">
                  <el-checkbox v-model="item.checked" :disabled="disabled"></el-checkbox>
                </el-col>
                <template v-if="applyVo.applyType === 'PAPER'">
                  <el-col :span="9">{{ isZh ? item.chineseName : item.englishName }}</el-col>
                  <el-col :span="5" class="fileuploadcontainer">
                    <div>{{ item.needUploadAttachment === 'Y' ? $t('lang.common.yes') : $t('lang.common.no') }}</div>
                    <div v-if="item.needUploadAttachment === 'Y'" style="margin-left: 40px">
                      <div @click="openDrawer(item)">
                        <i class="icon iconfont icon-shangchuanwenjian11"></i>
                        {{ item.attachmentName || $t('lang.common.uploadAttachment') }}
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="5" style="text-align:center">
                    <el-input-number size="mini" :min="1" v-model="item.copyNumber"
                                     :disabled="disabled || !item.checked"></el-input-number>
                  </el-col>
                  <el-col :span="2" class="fileprice">{{ certPrice(item) | moneyFormat }}</el-col>
                  <el-col :span="2" class="fileprice">{{ certChargeAmount(item) | moneyFormat }}
                  </el-col>
                </template>
                <template v-if="applyVo.applyType === 'ELECTRONIC'">
                  <el-col :span="10">{{ isZh ? item.chineseName : item.englishName }}</el-col>
                  <el-col :span="11" class="fileuploadcontainer">
                    <div>{{ item.needUploadAttachment === 'Y' ? $t('lang.common.yes') : $t('lang.common.no') }}</div>
                    <div v-if="item.needUploadAttachment === 'Y'" style="margin-left: 40px">
                      <div @click="openDrawer(item)">
                        <i class="icon iconfont icon-shangchuanwenjian11"></i>
                        {{ item.attachmentName || $t('lang.common.uploadAttachment') }}
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="2" class="fileprice">{{ certChargeAmount(item) | moneyFormat }}</el-col>
                </template>
              </el-row>
            </div>
          </el-collapse-item>
          <el-collapse-item name="diploma">
            <template slot="title">
              {{ $t('lang.chooseCert.diplomaCert') }}
              <i :class="isActive('diploma') ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
              <div class="price">
                <span class="unit">CNY</span>
                <span class="amount">{{ diplomaAmount | moneyFormat }}</span>
              </div>
            </template>
            <div class="filelist">
              <el-row class="rowheader">
                <template v-if="applyVo.applyType === 'PAPER'">
                  <el-col :offset="1" :span="9">{{ $t('lang.chooseCert.certName') }}</el-col>
                  <el-col :span="5">{{ $t('lang.chooseCert.needUploadAttachment') }}</el-col>
                  <el-col :span="5" style="text-align:center">{{ $t('lang.chooseCert.amount') }}</el-col>
                  <el-col :span="2" style="text-align:center">{{ $t('lang.chooseCert.price') }}</el-col>
                  <el-col :span="2" style="text-align:center">{{ $t('lang.chooseCert.sumAmount') }}</el-col>
                </template>
                <template v-if="applyVo.applyType === 'ELECTRONIC'">
                  <el-col :offset="1" :span="10">{{ $t('lang.chooseCert.certName') }}</el-col>
                  <el-col :span="11">{{ $t('lang.chooseCert.needUploadAttachment') }}</el-col>
                  <el-col :span="2" style="text-align: center">{{ $t('lang.chooseCert.sumAmount') }}</el-col>
                </template>
              </el-row>

              <el-row
                class="filerow"
                :class="item.checked ? 'rowselected' : ''"
                v-for="(item, index) in diplomaList"
                :key="index"
              >
                <el-col :span="1">
                  <el-checkbox v-model="item.checked" :disabled="disabled"></el-checkbox>
                </el-col>
                <template v-if="applyVo.applyType === 'PAPER'">
                  <el-col :span="9">{{ isZh ? item.chineseName : item.englishName }}</el-col>
                  <el-col :span="5" class="fileuploadcontainer">
                    <div>{{ item.needUploadAttachment === 'Y' ? $t('lang.common.yes') : $t('lang.common.no') }}</div>
                    <div v-if="item.needUploadAttachment === 'Y'" style="margin-left: 40px">
                      <div @click="openDrawer(item)">
                        <i class="icon iconfont icon-shangchuanwenjian11"></i>
                        {{ item.attachmentName || $t('lang.common.uploadAttachment') }}
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="5" style="text-align:center">
                    <el-input-number size="mini" :min="1" v-model="item.copyNumber"
                                     :disabled="disabled || !item.checked"></el-input-number>
                  </el-col>
                  <el-col :span="2" class="fileprice">{{ certPrice(item) | moneyFormat }}</el-col>
                  <el-col :span="2" class="fileprice">{{ certChargeAmount(item) | moneyFormat }}
                  </el-col>
                </template>
                <template v-if="applyVo.applyType === 'ELECTRONIC'">
                  <el-col :span="10">{{ isZh ? item.chineseName : item.englishName }}</el-col>
                  <el-col :span="11" class="fileuploadcontainer">
                    <div>{{ item.needUploadAttachment === 'Y' ? $t('lang.common.yes') : $t('lang.common.no') }}</div>
                    <div v-if="item.needUploadAttachment === 'Y'" style="margin-left: 40px">
                      <div @click="openDrawer(item)">
                        <i class="icon iconfont icon-shangchuanwenjian11"></i>
                        {{ item.attachmentName || $t('lang.common.uploadAttachment') }}
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="2" class="fileprice">{{ certChargeAmount(item) | moneyFormat }}</el-col>
                </template>
              </el-row>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="maincontainer">
        <div class="totalinfo">
          <div class="need-electronic-version" v-if="applyVo.applyType === 'PAPER'">
            <el-checkbox v-model="needElectronicVersion" :disabled="disabled">
              <div style="padding-left: 10px;">{{ $t('lang.chooseCert.needElectronicVersion') }}</div>
            </el-checkbox>
          </div>
          <!--          <div class="total-amount">{{ $t('lang.chooseCert.totalAmount') }}</div>
                    <div>CNY<br/>人民币</div>
                    <div class="total-amount-number">{{ standardAmount + nonStandardAmount + diplomaAmount | moneyFormat }}</div>-->
        </div>
      </div>
      <div class="maincontainer">
        <el-button
          size="mini"
          style="width: 250px"
          type="ceibs"
          @click="goto('confirmInfo')">
          {{ $t('lang.common.goBack') }}
        </el-button>
        <el-button
          size="mini"
          style="width: 250px"
          type="ceibsprimary"
          @click="submit"
          :disabled="disabled">
          {{ $t('lang.common.goNext') }}
        </el-button>
      </div>
    </el-main>
    <el-drawer
      :visible.sync="drawerVisible"
      direction="rtl"
      :before-close="closeDrawer">
      <template v-if="drawerOpCert">
        <div slot="title" class="dialogtitle">{{ $t('lang.common.uploadAttachment') }}</div>
        <el-upload action="https://jsonplaceholder.typicode.com/posts/"
                   drag
                   multiple
                   list-type="picture"
                   :http-request="doUpload"
                   :on-remove="onRemove"
                   :file-list="drawerFileList">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">{{ $t('lang.common.uploadTip') }}</div>
          <div class="el-upload__tip" slot="tip">
            {{ isZh ? drawerOpCert.uploadDescChinese : drawerOpCert.uploadDescEnglish }}
          </div>
        </el-upload>
      </template>
    </el-drawer>
  </el-container>
</template>

<script>
import CommonHeader from '@/components/common/commonHeader'
import { findCourse, getChargeConfig, getFileByFileUrl, listCert, uploadFile } from '@/api/base'
import { mapGetters } from 'vuex'
import languageType from '@/locales/languageType'
import { getAccessToken, getRefreshToken } from '@/util/util.ruquest'
import { loadStudentInfo } from '@/api/apply'

export default {
  name: 'chooseCert',
  components: { CommonHeader },
  props: {
    applyVo: {
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      certList: [],
      activeNames: ['standard'],
      selectedCert: [],
      drawerVisible: false,
      drawerFileList: [],
      drawerOpCert: null,
      needElectronicVersion: false,
      course: {},
      expediteChargeConfig: {},
      studentInfo: null
    }
  },
  computed: {
    ...mapGetters([
      'currentLanguage'
    ]),
    isLogin: function () {
      return getAccessToken() && getRefreshToken()
    },
    currentUserInSchool: function () {
      return this.studentInfo && this.studentInfo.STATUS === '0'
    },
    standardAmount: function () {
      let total = 0
      this.standardList.forEach(item => {
        total += item.checked && item.needCharge === 'Y' ? this.certChargeAmount(item) : 0
      })
      return total
    },
    nonStandardAmount: function () {
      let total = 0
      this.nonStandardList.forEach(item => {
        total += item.checked && item.needCharge === 'Y' ? this.certChargeAmount(item) : 0
      })
      return total
    },
    diplomaAmount: function () {
      let total = 0
      this.diplomaList.forEach(item => {
        total += item.checked && item.needCharge === 'Y' ? this.certChargeAmount(item) : 0
      })
      return total
    },
    isZh: function () {
      return this.currentLanguage === languageType.zh.code
    },
    standardList: function () {
      return this.certList.filter(cert => cert.certTypeCode === 'STANDARD_CERT').sort((c1, c2) => {
        if (this.isZh) {
          return c1.chineseName.localeCompare(c2.chineseName)
        } else {
          return c2.englishName.localeCompare(c2.englishName)
        }
      })
    },
    nonStandardList: function () {
      return this.certList.filter(cert => cert.certTypeCode === 'NONSTANDARD_CERT').sort((c1, c2) => {
        if (this.isZh) {
          return c1.chineseName.localeCompare(c2.chineseName)
        } else {
          return c2.englishName.localeCompare(c2.englishName)
        }
      })
    },
    diplomaList: function () {
      return this.certList.filter(cert => cert.certTypeCode === 'DIPLOMA_CERT').sort((c1, c2) => {
        if (this.isZh) {
          return c1.chineseName.localeCompare(c2.chineseName)
        } else {
          return c2.englishName.localeCompare(c2.englishName)
        }
      })
    }
  },
  mounted () {
    this.loadStudentInfo()
    this.loadCertList()
    this.needElectronicVersion = this.applyVo.applyType === 'PAPER' && this.applyVo.needElectronicVersion === 'Y'
    this.loadCourse()
    this.loadExpediteChargeConfig()
  },
  methods: {
    goto (url) {
      this.$router.push(url)
    },
    isActive (name) {
      return (
        this.activeNames.findIndex((item) => {
          return item === name
        }) > -1
      )
    },
    loadStudentInfo () {
      if (this.isLogin) {
        loadStudentInfo().then(res => {
          this.studentInfo = res.data
        })
      }
    },
    loadCertList () {
      listCert({
        courseId: this.applyVo.courseId,
        onlyElectronicVersion: this.applyVo.applyType === 'ELECTRONIC'
      }).then(res => {
        this.certList = res.data
        this.initCopyNumberAndCheckStatus()
        this.initSelectedCert()
      })
    },
    initCopyNumberAndCheckStatus () {
      this.certList.forEach(item => {
        this.$set(item, 'copyNumber', 1)
        this.$set(item, 'checked', false)
        this.$set(item, 'uploadedAttachment', [])
        this.$set(item, 'attachmentName', null)
      })
    },
    initSelectedCert () {
      if (this.applyVo.packVoList) {
        const packDetailVos = []
        this.applyVo.packVoList.forEach(packVo => {
          packDetailVos.push(...packVo.detailVoList)
        })
        this.certList.forEach(cert => {
          const curCertPackDetails = packDetailVos.filter(packDetailVo => packDetailVo.certId === cert.id)
          if (curCertPackDetails.length > 0) {
            cert.checked = true
            cert.uploadedAttachment = (curCertPackDetails[0]).userUploadAttachments.map(fileVo => {
              return {
                ...fileVo,
                name: fileVo.fileName
              }
            })
            cert.attachmentName = cert.uploadedAttachment.map(fileVo => fileVo.fileName).join(',')
            if (this.applyVo.applyType === 'PAPER') {
              let copyNumberSum = 0
              curCertPackDetails.forEach(detail => {
                copyNumberSum += detail.copyNumber
              })
              cert.copyNumber = copyNumberSum
            }
          }
        })
      }
    },
    openDrawer (item) {
      if (!this.disabled && item.checked && !this.drawerVisible) {
        item.uploadedAttachment.forEach(fileVo => {
          getFileByFileUrl(fileVo).then(blob => {
            if (blob) {
              this.drawerFileList.push({
                ...fileVo,
                name: fileVo.fileName,
                url: window.URL.createObjectURL(new Blob([blob]))
              })
            }
          })
        })
        this.drawerOpCert = item
        this.drawerVisible = true
      }
    },
    doUpload (param) {
      uploadFile(param.file, 'APPLY_CERT_ATTACHMENT').then(res => {
        getFileByFileUrl(res.data).then(blob => {
          if (blob) {
            this.drawerFileList.push({
              ...res.data,
              name: res.data.fileName,
              url: window.URL.createObjectURL(new Blob([blob]))
            })
          }
        })
      })
    },
    onRemove (file, fileList) {
      this.drawerFileList = fileList
    },
    closeDrawer (done) {
      this.drawerOpCert.uploadedAttachment = this.drawerFileList
      this.drawerOpCert.attachmentName = this.drawerOpCert.uploadedAttachment.map(fileVo => fileVo.fileName).join(',')
      this.drawerFileList = []
      this.drawerOpCert = null
      done()
    },
    submit () {
      const selectedCert = this.certList.filter(cert => cert.checked)
      if (selectedCert.length === 0) {
        this.$message.error(this.$t('lang.chooseCert.validate.atLeastOneCert'))
        return
      }
      const notUploadAttachmentCert = selectedCert.filter(cert => cert.needUploadAttachment === 'Y' && cert.uploadedAttachment.length === 0)
      if (notUploadAttachmentCert.length > 0) {
        const firstNotUploadAttachment = notUploadAttachmentCert[0]
        this.$message.error(this.$t('lang.chooseCert.validate.pleaseUploadAttachmentFor') + (this.isZh ? firstNotUploadAttachment.chineseName : firstNotUploadAttachment.englishName))
        return
      }
      this.$emit('submit', selectedCert, this.needElectronicVersion)
    },
    loadCourse () {
      findCourse({
        id: this.applyVo.courseId
      }).then(res => {
        this.course = res.data
      })
    },
    loadExpediteChargeConfig () {
      getChargeConfig({
        chargeType: 'EXPEDITE'
      }).then(res => {
        this.expediteChargeConfig = res.data
      })
    },
    certPrice (cert) {
      if (cert.needCharge === 'Y') {
        if (this.currentUserInSchool && cert.inSchoolStudentFree === 'Y') {
          return 0
        }
        if (cert.certChargeMode === 'UNIT_PRICE') {
          return cert.chargeAmountRmb
        } else if (cert.certChargeMode === 'FIRST_COPY') {
          return cert.firstCopyPriceRmb
        }
      }
      return 0
    },
    certChargeAmount (cert) {
      if (cert.needCharge === 'Y') {
        if (this.currentUserInSchool && cert.inSchoolStudentFree === 'Y') {
          return 0
        }
        if (cert.certChargeMode === 'UNIT_PRICE') {
          return cert.chargeAmountRmb * cert.copyNumber
        } else if (cert.certChargeMode === 'FIRST_COPY') {
          return cert.firstCopyPriceRmb + cert.chargeAmountRmb * (cert.copyNumber - 1)
        }
      }
      return 0
    }
  }
}
</script>

<style scoped>
.price {
  position: absolute;
  top: 0;
  right: 40px;
  line-height: 35px;
  font-family: Arial, Helvetica, sans-serif;
}

.price .unit {
  font-size: 18px;
}

.price .amount {
  margin-left: 40px;
}

/deep/ .el-collapse {
  border: none;
}

/deep/ .el-collapse-item {
  position: relative;
  margin-bottom: 25px;
}

/deep/ .el-collapse-item__header {
  background-color: #848484;
  color: #fff;
  text-align: center;
  display: block;
  border-left: 5px solid #a2100e;
  border-bottom: none;
  font-size: 16px;
  height: 35px;
  line-height: 35px;
  box-shadow: -1px 3px 11px 2px rgb(136 136 136 / 51%);
  position: relative;
}

/deep/ .el-collapse-item__header.is-active {
  background-color: #a2100e;
}

/deep/ .el-collapse-item__header i {
  font-size: 12px;
  margin-left: 15px;
}

/deep/ .el-collapse-item__arrow {
  display: none;
}

/deep/ .el-icon-arrow-right::before {
  content: "";
}

/deep/ .el-collapse-item__wrap {
  border: none;
}

.filelist {
  text-align: left;
  color: #707070;
}

/deep/ .el-upload {
  color: #707070;
}

/deep/ .el-collapse-item__content {
  padding-bottom: 0;
}

.filelist .rowheader {
  font-size: 12px;
  color: #a2100e;
  padding: 10px 0 5px 0;
}

.filelist .filerow {
  margin: 5px 0;
  font-size: 12px;
  line-height: 35px;
}

.filerow:nth-child(odd) {
  background-color: #ededed;
}

.filerow .el-col {
  line-height: 45px;
}

.filerow .fileuploadcontainer.el-col {
  line-height: 40px;
}

.filerow .el-col:first-child {
  background-color: #ffffff;
  line-height: 45px;
}

.filerow .el-col:nth-child(2),
.rowheader .el-col:first-child {
  padding-left: 15px;
}

.fileprice {
  /*text-align: left;*/
  text-align: center;
}

.rowselected .fileprice {
  color: #a2100e;

}

.fileuploadcontainer {
  display: flex;
  align-items: center;
  justify-content: left;
}

.fileuploadcontainer i {
  font-size: 25px;
}

.rowselected .fileuploadcontainer i {
  color: #a2100e;
}

.need-electronic-version {
  text-align: left;
  padding-left: 20px;
  color: #5b5b5b;
  margin-right: auto;
}

.totalinfo {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  text-align: right;
  padding-right: 30px;
  color: #5b5b5b;
  padding-bottom: 30px;
}

.totalinfo .total-amount {
  font-size: 36px;
  font-weight: bold;
}

.totalinfo .total-amount-number {
  font-size: 36px;
  color: #a2100e;
  margin-left: 15px
}

/deep/ .el-icon-minus::before {
  content: "\e7a2";
  font-size: 30px;
}

/deep/ .el-icon-plus::before {
  content: "\e7a0";
  font-size: 30px;
}

/deep/ .el-input-number__decrease {
  width: 24px;
  height: 24px;
  border: none;
  background-color: unset;
  left: 0;
  top: 0;
  color: #a2100e;
}

/deep/ .el-input-number__decrease.is-disabled, .el-input-number__increase.is-disabled {
  color: unset;
}

/deep/ .el-input-number__increase {
  width: 24px;
  height: 24px;
  border: none;
  background-color: unset;
  top: 0;
  right: 4px;
  color: #a2100e;
}

.el-upload-dragger:hover {
  border-color: #a2100e;
}

.dialogtitle {
  color: #a2100e;
}

.attachment-name {
  display: inline-block;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
